import { SEARCH_MIN_LENGTH, pluralizeSk } from '@repo/types'

/**
 * Vyhľadávanie v admine. Minimum dĺžky, `searchTerm` a `isSearchTooShort` sú zdieľané
 * s API a mobilom (@repo/types — common/search): s kratším textom sa nevyhľadáva,
 * zoznam ostane nefiltrovaný a pole ukáže SEARCH_TOO_SHORT_HINT.
 * Pole: components/ui/SearchInput, hooky: hooks/use-search.
 */
export { SEARCH_MIN_LENGTH, isSearchTooShort, searchTerm } from '@repo/types'

export const SEARCH_TOO_SHORT_HINT = `Zadajte aspoň ${SEARCH_MIN_LENGTH} ${pluralizeSk(SEARCH_MIN_LENGTH, ['znak', 'znaky', 'znakov'])}`

/** Text na porovnanie pri hľadaní v zozname na klientovi: malé písmená, bez diakritiky („Kováč" ~ „kovac"). */
export const foldDiacritics = (s: string) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
